export const modelStates = {
    START: 'start',
    FIRST_TRAINING: 'first_training',
    FIRST_TRAINING_ERROR: 'first_train_error',
    TRAINED: 'trained',
    TRAINING: 'training',
    EVALUATING: 'evaluating',
    UPDATING: 'updating',
    EVALUATION_ERROR: 'evaluation_error',
    EVALUATION_STOP: 'evaluation_stop',
    NOT_TRAINED: 'not_trained',
};

export const analysis = {
    FATAL_BALANCE: 9,
    WARNING_BALANCE: 5,
    FATAL_CARDINALITY: 30,
    WARNING_CARDINALITY: 80,

    WARNING: 0,
    FATAL: -1,
    NONE: 1
}

export const annotationValues = {
    CONFIRMED: "CONFIRMED",
    REJECTED: "REJECTED",
    HAND_INPUT: "HAND_INPUT",
    NOT_SURE: "NOT_SURE"
}

export const Color = {
    lightBlue: 'rgb(136,208,255)',
    orange: 'rgb(241,194,27)',
    gray: 'rgb(168,168,168)'
}